// src/pages/reportUsage/utils/checkIfOrderIsSubmitted.js

/**
 * Utility to check if the order is submitted/locked.
 * @param {Object} params - All required references and values.
 * @param {string} params.myCaseResourceType
 * @param {string} params.myCaseRefId
 * @param {Function} params.getOrderLockedAction
 * @param {Function} params.checkIfOrderLockedFunc
 * @param {string} [params.editStatus]
 * @returns {Promise<any>} - The order locked response
 */
export const checkIfOrderIsSubmittedUtil = async ({
  myCaseResourceType,
  myCaseRefId,
  getOrderLockedAction,
  checkIfOrderLockedFunc,
  editStatus
}) => {
  const currentOrderType =
    myCaseResourceType === 'reportUsage'
      ? 'ZLB'
      : myCaseResourceType === 'reportPayment'
      ? 'ZLB'
      : myCaseResourceType === 'draft'
      ? 'ZLB'
      : 'ZLC';
  const orderLockAction = getOrderLockedAction(
    myCaseResourceType === 'reportUsage'
      ? 'CTA_012'
      : myCaseResourceType === 'reportPayment'
      ? 'CTA_013'
      : myCaseResourceType === 'draft'
      ? 'CTA_005'
      : 'CTA_007',
    currentOrderType,
    ''
  );
  let orderLockedResponse = await checkIfOrderLockedFunc({
    action: orderLockAction,
    myCaseRefId: myCaseRefId,
    orderType: currentOrderType,
    editStatus: editStatus,
  });
  return orderLockedResponse;
};
